import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-off-white px-5 py-12 sm:py-20" data-id="element-71" data-mp="1hduloasc2p61">
      <div className="mx-auto max-w-2xl" data-id="element-72" data-mp="1cfjb1xu7samr">
        <h2 className="text-center font-serif-display text-2xl font-bold text-slate sm:text-4xl" data-id="element-73" data-mp="1ccdputophswb">
          Preguntas frecuentes
        </h2>

        <div className="mt-8 divide-y divide-sage/20 border-y border-sage/20" data-id="element-74" data-mp="252vyea878mh4">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-75" data-mp="205vsbzbcnjq0" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[48px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-76" data-mp="1v5rb272makyq">
                  <span className="text-sm font-semibold text-slate sm:text-base" data-id="element-77" data-mp="jq2npelgbjxe">
                    {faq.question}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage/15 text-dark-green" data-id="element-78" data-mp="1kp1lbeiogjry">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="1pkgx80x4k5lq" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="1aor7brotj8bq" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-81" data-mp="1fmsqsdq5p9nq">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-82" data-mp="11wyzlor6idau">
                      <p className="pb-4 text-sm leading-relaxed text-slate/70" data-id="element-83" data-mp="izfp0gp2ommb">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}